var exactLength = function (length) {
    return function (value) { return ("" + value).length === length; };
};

export { exactLength };
